import React, { useState, useEffect, useContext } from "react";
import { Drawer, Divider, Col, Row, Typography } from "antd";
import LeadContext from "../../contexts/leads";

const { Paragraph } = Typography;

const pStyle = {
  fontSize: 16,
  lineHeight: "24px",
  display: "block",
  marginBottom: 16
};

function Profile({ visible, setVisible, question, lead }) {
  const [answers, setAnswers] = useState({});
  const [ans, setAns] = useState({});
  const { supplyApi } = useContext(LeadContext);

  useEffect(() => {
    setAnswers(lead);
  }, [lead]);

  useEffect(() => {
    setAnswers(answers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ans]);

  useEffect(() => {
    const body = ans;

    ans.content &&
      supplyApi
        .post("leads/answer/", JSON.stringify(body))
        .then(response => console.log(response))
        .catch(err => {
          console.log(err);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ans]);

  const setAnswer = (e, con) => {
    var y = {
      lead: con.lead,
      question: con.question,
      content: e
    };
    setAns(y);
    var x = answers;
    x.answers.find(ans => ans.question === con.question).content = e;
    setAnswers(x);
  };
  const DescriptionItem = ({ title, content }) => {
    if (content && content.content) {
      return (
        <div
          className="site-description-item-profile-wrapper"
          style={{
            fontSize: 14,
            lineHeight: "22px",
            marginBottom: 7
          }}
        >
          <div className="site-description-item-profile-p">
            <Row>
              <Col span={12}>
                {title.shorthand ? title.shorthand : title.content}
              </Col>
              <Col span={10} offset={2}>
                {content && content.content !== "" && (
                  <Paragraph
                    editable={{ onChange: e => setAnswer(e, content) }}
                    style={{ marginLeft: 15 }}
                  >
                    {content.content}
                  </Paragraph>
                )}
              </Col>
            </Row>
            <Divider />
          </div>
        </div>
      );
    }
    return null;
  };
  return (
    <Drawer
      width={640}
      placement="right"
      closable={true}
      onClose={() => setVisible(false)}
      visible={visible}
    >
      <p className="site-description-item-profile-p" style={pStyle}>
        Lead Details
      </p>

      <Row>
        {question &&
          question.map((question, id) => {
            var ans =
              answers &&
              answers.answers &&
              answers.answers.find(ans => ans.question === question.id);
            return (
              <Col span={24} key={id}>
                <DescriptionItem
                  key={question.id}
                  title={question}
                  content={ans}
                />
              </Col>
            );
          })}
      </Row>
    </Drawer>
  );
}

export default Profile;
